import { AxiosResponse } from "axios";
import { aplClient } from "./apiClient";
import { PrintHistoryRequest } from "../types/printHistoryRequest";
import { browserName, browserVersion } from "react-device-detect";
import { stringContains } from "../aplUtils/stringUtills";
import { Dispatch } from "react";
import { ActionCreatorWithPayload, AnyAction } from "@reduxjs/toolkit";
import { ReduxStateLabelling } from "../types/redux/reduxStateLabelling";
import printJS from "print-js";
import { ReduxStateReprint } from "../types/redux/reduxStateReprint";

const combinePdf = async (printHistoryRequests: PrintHistoryRequest[]): Promise<AxiosResponse<string>> => {
    console.log("combinePdf printHistoryRequests", printHistoryRequests);
    return aplClient().post("pdf/combine", printHistoryRequests);
};

const getPdfByFileName = async (fileName: string): Promise<AxiosResponse<Blob>> => {
    return aplClient().get(`pdf/${fileName}`, { responseType: "blob" });
};

const getPdfUrl = (substring: string): string => `/api/pdf/${substring}`;

const getCombinedPdf = async (
    lblRdx: ReduxStateLabelling,
    dispatch: Dispatch<AnyAction>,
    onSetCombinedPdf: ActionCreatorWithPayload<any, "labelling/onSetCombinedPdf">
) => {
    const printerName = lblRdx.printed[0]?.printerName ?? "";

    const getPdfToPrint = (url: string) => {
        if (stringContains(printerName, "pdftoprint")) {
            if ((stringContains(browserName, "chrome") || stringContains(browserName, "edge")) && Number(browserVersion) >= 50) {
                printJS(url);
            } else {
                window.open(url, "_blank", "noreferrer");
            }
        }
    };
    if (stringContains(printerName, "pdf")) {
        if (lblRdx.printed.some(p => p.success)) {
            console.log("getCombinedPdf hit case 2");
            let pdf = await combinePdf(lblRdx.printed);
            getPdfToPrint(getPdfUrl(pdf.data));
            dispatch(onSetCombinedPdf(pdf.data));
        }
    }
};

const getCombinedPdfReprint = async (
    reprintRedux: ReduxStateReprint,
    dispatch: Dispatch<AnyAction>,
    onSetCombinedPdf: ActionCreatorWithPayload<any, "reprint/setReprintCombinedPdf">
) => {

    const printerName = reprintRedux.reprinted[0]?.printerName ?? "";

    const getPdfToPrint = (url: string) => {
        if (stringContains(printerName, "pdftoprint")) {
            if ((stringContains(browserName, "chrome") || stringContains(browserName, "edge")) && Number(browserVersion) >= 50) {
                printJS(url);
            } else {
                window.open(url, "_blank", "noreferrer");
            }
        }
    };

    if (stringContains(printerName, "pdf")) {
        if (reprintRedux.reprinted.some(p => p.success)) {
            let pdf = await combinePdf(reprintRedux.reprinted);
            getPdfToPrint(getPdfUrl(pdf.data));
            dispatch(onSetCombinedPdf(pdf.data));
        }
    }
};

export { combinePdf, getPdfByFileName, getCombinedPdf, getCombinedPdfReprint, getPdfUrl };
